export default {
  title: 'Gayrimenkul Satışlarının Dinamiği',
  x_axis: 'Tarih',
  y_axis: 'Satış Sayısı',
  districts: {
    alanya: 'Alanya',
    konyaalti: 'Konyaaltı',
    kemer: 'Kemer',
    kepez: 'Kepez',
    dosemealti: 'Döşemealtı',
    finike: 'Finike'
  }
}
